"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Heatmap = void 0;
var __1 = require("../..");
var predicate_1 = require("../../../common/predicate");
var constants_1 = require("../../../specs/constants");
var spec_factory_1 = require("../../../state/spec_factory");
var scale_defaults_1 = require("./scale_defaults");
var defaultProps = {
    chartType: __1.ChartType.Heatmap,
    specType: constants_1.SpecType.Series,
    data: [],
    xAccessor: function (_a) {
        var x = _a.x;
        return x;
    },
    yAccessor: function (_a) {
        var y = _a.y;
        return y;
    },
    xScale: { type: scale_defaults_1.X_SCALE_DEFAULT.type },
    valueAccessor: function (_a) {
        var value = _a.value;
        return value;
    },
    valueFormatter: function (value) { return "" + value; },
    xSortPredicate: predicate_1.Predicate.AlphaAsc,
    ySortPredicate: predicate_1.Predicate.AlphaAsc,
    timeZone: 'UTC',
    xAxisLabelName: 'X Value',
    xAxisLabelFormatter: String,
    yAxisLabelName: 'Y Value',
    yAxisLabelFormatter: String,
};
exports.Heatmap = (0, spec_factory_1.getConnect)()((0, spec_factory_1.specComponentFactory)(defaultProps));
//# sourceMappingURL=heatmap.js.map